/**
 * Vasim Hayat @ 2/10/2018
 */

export class FnWeatherConstatnt {

  public static readonly WEATHER_ICONS = {
    Chance_of_Flurries: 'fn-global-day-cloudy-gusts',
    Chance_of_Rain: 'fn-global-rain',
    Chance_of_Freezing_Rain: 'fn-global-rain-wind',
    Chance_of_Sleet: 'fn-global-storm-showers',
    Chance_of_Snow: 'fn-global-snow',
    Chance_of_Thunderstorms: 'fn-global-thunderstorm',
    Chance_of_a_Thunderstorm: 'fn-global-thunderstorm',
    Clear: 'fn-global-day-sunny',
    Cloudy: 'fn-global-cloudy',
    Clouds: 'fn-global-cloudy',
    Flurries: 'fn-global-day-cloudy-gusts',
    Fog: 'fn-global-fog',
    Haze: 'fn-global-day-fog',
    Mostly_Cloudy: 'fn-global-day-cloudy',
    Mostly_Sunny: 'fn-global-day-sunny-overcast',
    Partly_Cloudy: 'fn-global-day-cloudy',
    Partly_Sunny: 'fn-global-day-sunny-overcast',
    Freezing_Rain: 'fn-global-rain-wind',
    Rain: 'fn-global-rain',
    Sleet: 'fn-global-storm-showers',
    Snow: 'fn-global-snow',
    Sunny: 'fn-global-day-sunny',
    Thunderstorms: 'fn-global-thunderstorm',
    Thunderstorm: 'fn-global-thunderstorm',
    Overcast: 'fn-global-day-sunny-overcast',
    Rain_Showers: 'fn-global-showers',
    Snow_Showers: 'fn-global-snow',
    Scattered_Clouds: 'fn-global-day-lightning',
    'Light Rain': 'fn-global-rain-mix',
    'Light Freezing Rain': 'fn-global-hail ',
    'Light Snow': 'fn-global-snow',
    'Light Drizzle': 'fn-global-rain-mix',
    Ice_Pellets: 'fn-global-rain-mix '
  };


  public static readonly WEATHER_STRINGS = {
    en: {
      Chance_of_Flurries: 'Chance of Flurries',
      Chance_of_Rain: 'Chance of Rain',
      Chance_of_Freezing_Rain: 'Chance of Freezing Rain',
      Chance_of_Sleet: 'Chance of Sleet',
      Chance_of_Snow: 'Chance of Snow',
      Chance_of_Thunderstorms: 'Chance of Thunderstorms',
      Chance_of_a_Thunderstorm: 'Chance of a Thunderstorm',
      Clear: 'Clear',
      Cloudy: 'Cloudy',
      Clouds: 'Cloudy',
      Flurries: 'Flurries',
      Fog: 'Fog',
      Haze: 'Haze',
      Mostly_Cloudy: 'Mostly Cloudy',
      Mostly_Sunny: 'Mostly Sunny',
      Partly_Cloudy: 'Partly Cloudy',
      Partly_Sunny: 'Partly Sunny',
      Freezing_Rain: 'Freezing Rain',
      Rain: 'Rain',
      Sleet: 'Sleet',
      Snow: 'Snow',
      Sunny: 'Sunny',
      Thunderstorms: 'Thunderstorms',
      Thunderstorm: 'Thunderstorm',
      Overcast: 'Overcast',
      Snow_Showers: 'Snow Showers',
      'N/A': 'N/A',
      Scattered_Clouds: 'Scattered Clouds',
      'Light Rain': 'Light Rain',
      'Light Freezing Rain': 'Light Freezing Rain',
      'Light Snow': 'Light Snow',
      'Light Drizzle': 'Light Drizzle',
      Ice_Pellets: 'fn-global-rain-mix '
    },
    es: {
      Chance_of_Flurries: 'Chance of Flurries',
      Chance_of_Rain: 'Chance of Rain',
      Chance_of_Freezing_Rain: 'Chance of Freezing Rain',
      Chance_of_Sleet: 'Chance of Sleet',
      Chance_of_Snow: 'Chance of Snow',
      Chance_of_Thunderstorms: 'Chance of Thunderstorms',
      Chance_of_a_Thunderstorm: 'Chance of a Thunderstorm',
      Clear: 'Clear',
      Cloudy: 'Cloudy',
      Clouds: 'Cloudy',
      Flurries: 'Flurries',
      Fog: 'Fog',
      Haze: 'Haze',
      Mostly_Cloudy: 'Mostly Cloudy',
      Mostly_Sunny: 'Mostly Sunny',
      Partly_Cloudy: 'Partly Cloudy',
      Partly_Sunny: 'Partly Sunny',
      Freezing_Rain: 'Freezing Rain',
      Rain: 'Rain',
      Sleet: 'Sleet',
      Snow: 'Snow',
      Sunny: 'Sunny',
      Thunderstorms: 'Thunderstorms',
      Thunderstorm: 'Thunderstorm',
      Overcast: 'Overcast',
      Snow_Showers: 'Snow Showers',
      'N/A': 'N/A',
      Scattered_Clouds: 'Scattered Clouds',
      'Light Rain': 'Light Rain',
      'Light Freezing Rain': 'Light Freezing Rain',
      'Light Snow': 'Light Snow',
      'Light Drizzle': 'Light Drizzle',
      Ice_Pellets: 'fn-global-rain-mix '
    },
    fr: {
      Chance_of_Flurries: 'Chance of Flurries',
      Chance_of_Rain: 'Chance of Rain',
      Chance_of_Freezing_Rain: 'Chance of Freezing Rain',
      Chance_of_Sleet: 'Chance of Sleet',
      Chance_of_Snow: 'Chance of Snow',
      Chance_of_Thunderstorms: 'Chance of Thunderstorms',
      Chance_of_a_Thunderstorm: 'Chance of a Thunderstorm',
      Clear: 'Clear',
      Cloudy: 'Cloudy',
      Clouds: 'Cloudy',
      Flurries: 'Flurries',
      Fog: 'Fog',
      Haze: 'Haze',
      Mostly_Cloudy: 'Mostly Cloudy',
      Mostly_Sunny: 'Mostly Sunny',
      Partly_Cloudy: 'Partly Cloudy',
      Partly_Sunny: 'Partly Sunny',
      Freezing_Rain: 'Freezing Rain',
      Rain: 'Rain',
      Sleet: 'Sleet',
      Snow: 'Snow',
      Sunny: 'Sunny',
      Thunderstorms: 'Thunderstorms',
      Thunderstorm: 'Thunderstorm',
      Overcast: 'Overcast',
      Snow_Showers: 'Snow Showers',
      'N/A': 'N/A',
      Scattered_Clouds: 'Scattered Clouds',
      'Light Rain': 'Light Rain',
      'Light Freezing Rain': 'Light Freezing Rain',
      'Light Snow': 'Light Snow',
      'Light Drizzle': 'Light Drizzle',
      Ice_Pellets: 'fn-global-rain-mix '
    },
    zh: {
      Chance_of_Flurries: 'Chance of Flurries',
      Chance_of_Rain: 'Chance of Rain',
      Chance_of_Freezing_Rain: 'Chance of Freezing Rain',
      Chance_of_Sleet: 'Chance of Sleet',
      Chance_of_Snow: 'Chance of Snow',
      Chance_of_Thunderstorms: 'Chance of Thunderstorms',
      Chance_of_a_Thunderstorm: 'Chance of a Thunderstorm',
      Clear: 'Clear',
      Cloudy: 'Cloudy',
      Clouds: 'Cloudy',
      Flurries: 'Flurries',
      Fog: 'Fog',
      Haze: 'Haze',
      Mostly_Cloudy: 'Mostly Cloudy',
      Mostly_Sunny: 'Mostly Sunny',
      Partly_Cloudy: 'Partly Cloudy',
      Partly_Sunny: 'Partly Sunny',
      Freezing_Rain: 'Freezing Rain',
      Rain: 'Rain',
      Sleet: 'Sleet',
      Snow: 'Snow',
      Sunny: 'Sunny',
      Thunderstorms: 'Thunderstorms',
      Thunderstorm: 'Thunderstorm',
      Overcast: 'Overcast',
      Snow_Showers: 'Snow Showers',
      'N/A': 'N/A',
      Scattered_Clouds: 'Scattered Clouds',
      'Light Rain': 'Light Rain',
      'Light Freezing Rain': 'Light Freezing Rain',
      'Light Snow': 'Light Snow',
      'Light Drizzle': 'Light Drizzle',
      Ice_Pellets: 'fn-global-rain-mix '
    },
    it: {
      Chance_of_Flurries: 'Chance of Flurries',
      Chance_of_Rain: 'Chance of Rain',
      Chance_of_Freezing_Rain: 'Chance of Freezing Rain',
      Chance_of_Sleet: 'Chance of Sleet',
      Chance_of_Snow: 'Chance of Snow',
      Chance_of_Thunderstorms: 'Chance of Thunderstorms',
      Chance_of_a_Thunderstorm: 'Chance of a Thunderstorm',
      Clear: 'Clear',
      Cloudy: 'Cloudy',
      Clouds: 'Cloudy',
      Flurries: 'Flurries',
      Fog: 'Fog',
      Haze: 'Haze',
      Mostly_Cloudy: 'Mostly Cloudy',
      Mostly_Sunny: 'Mostly Sunny',
      Partly_Cloudy: 'Partly Cloudy',
      Partly_Sunny: 'Partly Sunny',
      Freezing_Rain: 'Freezing Rain',
      Rain: 'Rain',
      Sleet: 'Sleet',
      Snow: 'Snow',
      Sunny: 'Sunny',
      Thunderstorms: 'Thunderstorms',
      Thunderstorm: 'Thunderstorm',
      Overcast: 'Overcast',
      Snow_Showers: 'Snow Showers',
      'N/A': 'N/A',
      Scattered_Clouds: 'Scattered Clouds',
      'Light Rain': 'Light Rain',
      'Light Freezing Rain': 'Light Freezing Rain',
      'Light Snow': 'Light Snow',
      'Light Drizzle': 'Light Drizzle',
      Ice_Pellets: 'fn-global-rain-mix '
    },
    de: {
      Chance_of_Flurries: 'Chance of Flurries',
      Chance_of_Rain: 'Chance of Rain',
      Chance_of_Freezing_Rain: 'Chance of Freezing Rain',
      Chance_of_Sleet: 'Chance of Sleet',
      Chance_of_Snow: 'Chance of Snow',
      Chance_of_Thunderstorms: 'Chance of Thunderstorms',
      Chance_of_a_Thunderstorm: 'Chance of a Thunderstorm',
      Clear: 'Clear',
      Cloudy: 'Cloudy',
      Clouds: 'Cloudy',
      Flurries: 'Flurries',
      Fog: 'Fog',
      Haze: 'Haze',
      Mostly_Cloudy: 'Mostly Cloudy',
      Mostly_Sunny: 'Mostly Sunny',
      Partly_Cloudy: 'Partly Cloudy',
      Partly_Sunny: 'Partly Sunny',
      Freezing_Rain: 'Freezing Rain',
      Rain: 'Rain',
      Sleet: 'Sleet',
      Snow: 'Snow',
      Sunny: 'Sunny',
      Thunderstorms: 'Thunderstorms',
      Thunderstorm: 'Thunderstorm',
      Overcast: 'Overcast',
      Snow_Showers: 'Snow Showers',
      'N/A': 'N/A',
      Scattered_Clouds: 'Scattered Clouds',
      'Light Rain': 'Light Rain',
      'Light Freezing Rain': 'Light Freezing Rain',
      'Light Snow': 'Light Snow',
      'Light Drizzle': 'Light Drizzle',
      Ice_Pellets: 'fn-global-rain-mix '
    },
  };
}
